import { Image, View } from '@react-pdf/renderer';
import React from 'react';
import { dangerImg } from 'src/components/pdf/imgData';

interface DangerProps {
  noMarginBottom?: boolean;
}
export const Danger: React.FC<DangerProps> = ({ noMarginBottom }) => {
  return (
    <View style={{ marginBottom: noMarginBottom ? 0 : 3 }}>
      <Image style={{ width: 12, height: 12 }} src={dangerImg} />
    </View>
  );
};
